import React from "react";
import { Box, Container, Typography } from "@mui/material";

const ASSETS = {
  logo: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1758641295/EMBATE/Logo-EMBATE_pagina_yxozxg.png",
  rectBig: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1758641762/EMBATE/Rectangle_34625849_ut6hex.png",
  rectSmall: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1758641763/EMBATE/Rectangle_34625848_bwua1h.png",
  bg: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1758645547/EMBATE/EN_CONTRUCCI%C3%93N_1_bgfbpf.jpg",
};

const COLORS = { pageBg: "#F7FAFD", orange: "#F57C00" };

export default function EmbateComingSoon() {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        backgroundImage: `url("${ASSETS.bg}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <Container
        maxWidth="xl"
        disableGutters
        sx={{
          position: "relative",
          zIndex: 1,
          mt: { xs: 0, md: 25 },
          pb: { xs: 0, md: 10 },
          px: { xs: 0, md: 0 },
        }}
      >
        {/* ================= MOBILE (xs–sm) EXACTO ================= */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          {/* 253px desde el inicio al tope del logo */}
          <Box sx={{ height: "253px" }} />

          {/* Logo centrado */}
          <Box sx={{ display: "flex", justifyContent: "center", px: 2 }}>
            <Box
              component="img"
              src={ASSETS.logo}
              alt="EMBATE"
              sx={{ width: "clamp(180px, 55vw, 260px)", height: "auto" }}
            />
          </Box>

          {/* 154px entre logo y franja */}
          <Box sx={{ height: "154px" }} />

          {/* Franja PRÓXIMAMENTE full-bleed */}
          <Box sx={{ width: "100vw", ml: "calc(50% - 50vw)" }}>
            <Box
              sx={{
                height: { xs: 148, sm: 168 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                  "linear-gradient(90deg, #0C2A3A 0%, #114367 20%, #1C5B8E 55%, #2E6EB6 100%)",
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  letterSpacing: "0.18em",
                  fontSize: { xs: "clamp(18px, 5.6vw, 24px)", sm: 26 },
                  lineHeight: 1.2,
                  whiteSpace: "nowrap",
                }}
              >
                PRÓXIMAMENTE
              </Typography>
            </Box>
          </Box>

          {/* Línea naranja full-bleed + etiqueta centrada */}
          <Box sx={{ mt: 2 }}>
            <Box
              sx={{
                width: "100vw",
                ml: "calc(50% - 50vw)",
                position: "relative",
                minHeight: 32,
              }}
            >
              <Box
                sx={{
                  borderTop: `2px solid ${COLORS.orange}`,
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 0,
                }}
              />
              <Typography
                sx={{
                  position: "relative",
                  bgcolor: COLORS.pageBg,
                  px: 1.6,
                  py: 0.3,
                  mx: "auto",
                  color: COLORS.orange,
                  fontWeight: 700,
                  letterSpacing: "0.1em",
                  fontSize: "clamp(12px, 3.4vw, 14px)",
                  zIndex: 1,
                  width: "fit-content",
                  whiteSpace: "nowrap",
                  borderRadius: 0.5,
                }}
              >
                SITIO EN CONSTRUCCIÓN
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ================= DESKTOP/TABLET (md+): DISEÑO ORIGINAL ================= */}
        <Box
          sx={{
            display: { xs: "none", md: "grid" },
            gridTemplateColumns: "minmax(520px, 45%) 15px 1fr",
            alignItems: "center",
            rowGap: 0,
            px: 0,
          }}
        >
          {/* Columna izquierda: logo + rectángulo pequeño */}
          <Box sx={{ gridColumn: "1" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "53px",
                mt: 14,
              }}
            >
              <Box
                component="img"
                src={ASSETS.logo}
                alt="EMBATE"
                sx={{
                  width: 360,
                  height: "auto",
                  display: "block",
                  alignSelf: "flex-end",
                  mr: 2,
                  mt: -5,
                }}
              />
              <Box
                component="img"
                src={ASSETS.rectSmall}
                alt="Decoración"
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  // FULL-BLEED en pantallas muy grandes
                  "@media (min-width:1800px)": {
                    width: "100vw",
                    ml: "calc(50% - 50vw)",
                  },
                }}
              />
            </Box>
          </Box>

          {/* Columna derecha: rectángulo grande + “PRÓXIMAMENTE” */}
          <Box
            sx={{
              gridColumn: "3",
              position: "relative",
              mt: "50px",
              // FULL-BLEED en pantallas muy grandes
              "@media (min-width:1800px)": {
                width: "100vw",
                ml: "calc(50% - 50vw)",
              },
            }}
          >
            <Box
              component="img"
              src={ASSETS.rectBig}
              alt="Bloque principal"
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
                borderRadius: 0,
              }}
            />
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 4,
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  letterSpacing: "0.22em",
                  fontWeight: 700,
                  textAlign: "center",
                  fontSize: "2.6rem",
                  whiteSpace: "nowrap",
                }}
              >
                PRÓXIMAMENTE
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ================= CINTA INFERIOR ================= */}
        <Box sx={{ mt: { xs: 3, md: 2 } }}>
          {/* Desktop: desplazada a la derecha como tu diseño.
              En pantallas muy grandes la línea se hace full-bleed. */}
          <Box
            sx={{
              position: "relative",
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              // FULL-BLEED en pantallas muy grandes
              "@media (min-width:1800px)": {
                width: "100vw",
                ml: "calc(50% - 50vw)",
              },
            }}
          >
            {/* Línea naranja completa */}
            <Box
              sx={{
                borderTop: `2px solid ${COLORS.orange}`,
                position: "absolute",
                left: 0,
                right: 0,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 0,
              }}
            />
            {/* Texto desplazado hacia la derecha */}
            <Typography
              sx={{
                position: "relative",
                bgcolor: COLORS.pageBg,
                px: 1.5,
                ml: "60%",
                mr: "10%",
                color: COLORS.orange,
                fontWeight: 700,
                fontSize: "24px",
                letterSpacing: "0.12em",
                zIndex: 1,
                whiteSpace: "nowrap",
              }}
            >
              SITIO EN CONSTRUCCIÓN
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
